<app-modal-base
  [title]="'PAYMENT_REPORT.transactionId' | translate"
  [showCloseIcon]="true"
  [primaryButtonText]="'submit' | translate"
  [secondaryButtonText]="'payment_flow.Cancel' | translate"
  [primaryButtonId]="'submit-txid'"
  [primaryButtonDisabled]="!transactionId?.trim()"
  [modalClass]="'max-w-[90vw] md:max-w-lg'"
  (close)="dialogRef.close(false)"
  (primaryClick)="finishTransaction()"
  (secondaryClick)="dialogRef.close(false)"
>
  <div class="space-y-4">
    <div
      class="space-y-2 rounded-lg custom-border-gray-light text-base text-left font-normal w-full shadow-[0_0_4px_#0000000d] p-2 [&&]:px-x-small"
      id="payment-deadline"
    >
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-2">
          <h2 class="font-bold text-base text-[#202b42] confirmation-tab-lower-label">
            {{ 'informTheTransactionId' | translate }}

            <i
              class="ph ph-info clickable tooltip-icon"
              #tooltip="matTooltip"
              matTooltip="{{ 'useYourPreferredCryptoWallet' | translate }}"
              matTooltipPosition="above"
              toggleMatTooltip
            ></i>
          </h2>
        </div>
        <span class="font-semibold text-[#929292] text-base confirmation-tab-mobile-label">
          {{ !data.sameAssets() ? paymentUtils.formatTimer(data.refreshQuotesTimerInSeconds.toString()) : '' }}
        </span>
      </div>
      <div
        class="h-1 rounded-full"
        [style.background]="data.fillTimeLapseBar(data.refreshQuotesTimerInSeconds, data.totalTimeInMinutes * 60)"
      ></div>
    </div>

    <div>
      <label class="block text-sm font-medium text-[#929292] mb-4" [innerHTML]="getInformingPhrase()"></label>
      <div class="mt-4">
        <input
          type="text"
          [class.border-red-500]="
            !payment.controls['transactionId']?.valid && payment.controls['transactionId'].touched
          "
          [(ngModel)]="transactionId"
          (ngModelChange)="payment.controls['transactionId'].setValue(transactionId)"
          class="w-full p-2 border rounded-md shadow-sm !hidden md:!block form-input-base"
          id="txId"
          name="transaction-id"
          placeholder="{{ 'PAYMENT_REPORT.transactionId' | translate }}"
        />

        <textarea
          [class.border-red-500]="
            !payment.controls['transactionId']?.valid && payment.controls['transactionId'].touched
          "
          [(ngModel)]="transactionId"
          (ngModelChange)="payment.controls['transactionId'].setValue(transactionId)"
          class="w-full p-2 border rounded-md shadow-sm md:!hidden"
          id="txId"
          name="transaction-id"
          placeholder="{{ 'PAYMENT_REPORT.transactionId' | translate }}"
        ></textarea>
      </div>
      <a
        appClipboardPermission
        class="underline text-sm mt-2 block text-blue-600 cursor-pointer"
        (click)="pasteTransactionId()"
      >
        {{ 'pasteFromClipboard' | translate }}
      </a>
    </div>
  </div>
</app-modal-base>
